<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Srt. Peringatan
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="saveimportdata()">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="no_kontrak">No.Kontrak</b-form-checkbox>
                  <b-form-checkbox value="nosurat">No. Surat</b-form-checkbox>
                  <b-form-checkbox value="namasurat">Jenis SP</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(no_kontrak)="data">
            <span
              v-if="data.item.pinjamankey==''"
              class="text-danger"
              v-b-tooltip.hover
              title="No Kontrak Tidak Ada di database"
            >{{data.item.no_kontrak}}</span>
            <span v-else>{{data.item.no_kontrak}}</span>
          </template>
          <template v-slot:cell(tglsurat)="data">{{ data.item.tglsurat | moment("YYYY-MM-DD") }}</template>
          <template v-slot:cell(jenissurat)="data">
            <span
              v-if="data.item.jenissuratkey==''"
              class="text-danger"
              v-b-tooltip.hover
              title="Jenis surat tidak sesuai"
            >{{data.item.jenissurat}}</span>
            <span v-else>{{data.item.jenissurat}}</span>
          </template>
          <template
            v-slot:cell(tunggakanbunga)="data"
          >{{ data.item.tunggakanbunga | numFormat("0,0.00") }}</template>
          <template
            v-slot:cell(tunggakandenda)="data"
          >{{ data.item.tunggakandenda | numFormat("0,0.00") }}</template>
          <template
            v-slot:cell(tunggakanpokok)="data"
          >{{ data.item.tunggakanpokok | numFormat("0,0.00") }}</template>
          <template
            v-slot:cell(tunggakantotal)="data"
          >{{ data.item.tunggakantotal | numFormat("0,0.00") }}</template>
          <!-- <template v-slot:custom-foot>
            <b-td colspan="7">
              <h6 class="text-right">Total</h6>
            </b-td>
            <b-td>
              <h6 class="text-right">{{total| numFormat("0,0.00")}}</h6>
            </b-td>
            <b-td colspan="4"></b-td>
          </template>-->
        </b-table>
        <b-row class="mt-2">
          <b-col lg="10">
            <b-row>
              <b-col cols="2">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
              <b-col cols="10">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2">
            <b-row align-h="right">
              <b-col md="12">
                <b-form-group label="Total Tunggakan">
                  <my-number
                    class="form-control text-right"
                    v-model="total"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="10">
        <b-card>
          <div slot="header">
            Import Data Srt. Peringatan
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Fileld pada data Srt. Peringatan</strong>
            <b-row class="mt-2">
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.no_kontrak"
                    :state="!$v.frmUpload.no_kontrak.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl. Surat</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tglsurat"
                    :state="!$v.frmUpload.tglsurat.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Surat</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.nosurat"
                    :state="!$v.frmUpload.nosurat.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jenis Surat</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.jenissurat"
                    :state="!$v.frmUpload.jenissurat.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tunggakan Pokok</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tunggakanpokok"
                    :state="!$v.frmUpload.tunggakanpokok.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tunggakan Denda</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tunggakandenda"
                    :state="!$v.frmUpload.tunggakandenda.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tunggakan Bunga</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tunggakanbunga"
                    :state="!$v.frmUpload.tunggakanbunga.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tunggakan Total</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tunggakantotal"
                    :state="!$v.frmUpload.tunggakantotal.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TTD Nama #1</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.ttd1nama"
                    :state="!$v.frmUpload.ttd1nama.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TTD Jabatan #1</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.ttd1jabatan"
                    :state="!$v.frmUpload.ttd1jabatan.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TTD Nama #2</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.ttd2nama" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TTD Jabatan #2</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.ttd2jabatan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="Boolean(fileXlsx)"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required,minLength} from "vuelidate/lib/validators";
toastr.init();
import speringatan from "../../apis/suratperingatan";
import kolomXls from "../../data/kolomXls";
import crud from "../../apis/crud";

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      no_kontrak: { required },
      tglsurat: { required },
      nosurat: { required },
      jenissurat: { required },
      tunggakanpokok: { required },
      tunggakandenda: { required },
      tunggakanbunga: { required },
      tunggakantotal: { required },
      ttd1nama: { required },
      ttd1jabatan: { required },
    },
    fileXlsx: { required },
    rptLines: {
      required,
      minLength: minLength(1),
      $each: {
        pinjamankey: {
          required,
        },
        jenissuratkey: {
          required,
        },
      },
    },
  },
  data() {
    return {
      showUploadFrm: true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "SP_LIST",
        startRow: 3,
        no_kontrak: "A",
        nomoridentitas: "B",
        tglsurat: "C",
        nosurat: "D",
        jenissurat: "E",
        tunggakanpokok: "F",
        tunggakandenda: "G",
        tunggakanbunga: "H",
        tunggakantotal: "I",
        ttd1nama: "J",
        ttd1jabatan: "K",
        ttd2nama: "L",
        ttd2jabatan: "M",
      },
      kolomXls: kolomXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      rptLines: [],
      total: 0,
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "no_kontrak",
            label: "No.Kontrak",
            sortable: true,
          },
          {
            key: "tglsurat",
            label: "Tgl Surat",
            sortable: true,
          },
          {
            key: "nosurat",
            label: "No. Surat",
            sortable: true,
          },
          {
            key: "jenissurat",
            label: "Jenis SP",
            sortable: true,
          },
          {
            key: "tunggakanpokok",
            label: "Tunggakan Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "tunggakandenda",
            label: "Tunggakan Denda",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "tunggakanbunga",
            label: "Tunggakan Bunga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "tunggakantotal",
            label: "Tunggakan Total",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "ttd1nama",
            label: "TTD#1 Nama",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "ttd1jabatan",
            label: "TTD#1 Jabatan",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "ttd2nama",
            label: "TTD#2 Nama",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "ttd2jabatan",
            label: "TTD#2 Jabatan",
            thStyle: "width:140px",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidRptLines() {
      this.$v.rptLines.$touch();
      return this.$v.rptLines.$invalid;
    },
    account() {
      return this.model.account;
    },
  },
  watch: {
    account: function (newval) {
      const obj = this.accounts.find((d) => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
      // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
  },
  created:async function(){
    const collSet = { tablename: "uploadsperingatan" };
    const uploadDt = await crud.list(collSet);
    if (uploadDt.length > 0) {
      const objDt = uploadDt[0];
      for (const key in objDt) {
        if ((objDt[key] || "") != "") {
          this.frmUpload[key] = objDt[key];
        }
      }
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      this.total = filteredItems.reduce((ttl = 0, item) => {
            ttl += item.tunggakantotal || 0;
            return ttl;
          }, 0);
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    async importdata() {
      if (this.invalidFrmUpload || this.invalidFileXlsx) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const dt = await speringatan.importdtxls(
            this.fileXlsx,
            this.frmUpload
          );
          this.total = dt.reduce((ttl = 0, item) => {
            ttl += item.tunggakantotal || 0;
            return ttl;
          }, 0);
          this.rptLines = dt;
          this.isLoading = false;
          this.showUploadFrm = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async saveimportdata() {
      if(this.invalidRptLines){
        toastr.error("Periksa kembali data yang akan diimport.");
      }else{
        try {
          this.isLoading = true;
          await speringatan.savebulk(this.rptLines);
          toastr.success("Data berhasil diimport");
          this.isLoading = false;
         } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    cancel() {
      this.rptLines = [];
      this.showUploadFrm = true;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
